import { HeroSize } from '../HeroArea/consts';
import HeroArea from '../HeroArea/HeroArea';
import { HeroAreaProps } from '../HeroArea/interfaces';

const SmallHeroArea = (props: HeroAreaProps) => {
  return <HeroArea {...props} size={HeroSize.Small} />;
};
export default SmallHeroArea;
